import React from "react";
import styled from "styled-components";
const Styles = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  font-size: 20px;
  font-weight: 500;
  margin: 0.3rem 0;
  &.smaller {
    font-size: 16px;
  }
  .sub{
    font-size: var(--fs-small);
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 0.5rem;
  }
  @media screen and (max-width: 1445px) {
  }
`;

export const Title = ({ style, children, className , subtitle}) => {
  return (
    <Styles style={style} className={className}>
      {children}
      <div className="sub">
        {(subtitle) ? (
          `(${subtitle})`
        ) : ''}
      </div>
    </Styles>
  );
};
